import { GameState } from 'src/enums/game-state.enum';
import { reduxEventTypes } from 'src/types';
import { EventCreateResultType, EventEditResultType, EventResultType } from 'src/types/services/events-service.type';
import {
  EVENTS_SET,
  EVENT_ADDED,
  EVENT_DATA_CHANGED,
  EVENT_DATE_CHANGED,
  EVENT_DELETED,
  EVENT_EDITED,
  EVENT_ID_CHANGED,
  EVENT_TIME_PREFERENCE_CHANGED,
  EVENT_UNIX_TIME_CHANGED,
  EVENT_STATE_CHANGED,
  SURFER_STATE_CHANGED,
  TH_TC_CHANGED,
  HYMOTSE_LOGIN,
  HLA_CONTENT_CHANGED,
} from '../redux-types/event.types';
import { HLAGuncellemeType } from 'src/types/components/socket.type';
import { EventTimePreference } from 'src/enums/eventTimePreference.enum';

export const eventList = (list: reduxEventTypes.EventInformation[]) => {
  return {
    type: EVENTS_SET,
    payload: list,
  };
};
export const eventAdded = (payload: EventResultType) => {
  return {
    type: EVENT_ADDED,
    payload,
  };
};
export const eventEdited = (payload: EventEditResultType) => {
  return {
    type: EVENT_EDITED,
    payload,
  };
};

export const eventDeleted = (payload: string) => {
  return {
    type: EVENT_DELETED,
    payload,
  };
};
export const eventStateChanged = (payload: GameState) => {
  return {
    type: EVENT_STATE_CHANGED,
    payload,
  };
};

export const eventDateChanged = (payload: number) => {
  return {
    type: EVENT_DATE_CHANGED,
    payload,
  };
};

export const surferStateChanged = (payload: boolean | undefined) => {
  return {
    type: SURFER_STATE_CHANGED,
    payload,
  };
};

export const tcThChanged = (payload: { tc: number; th: number }) => {
  return {
    type: TH_TC_CHANGED,
    payload,
  };
};

export const eventIdChanged = (payload: string) => {
  return {
    type: EVENT_ID_CHANGED,
    payload,
  };
};

export const eventTimePreferenceChanged = (payload: EventTimePreference) => {
  return {
    type: EVENT_TIME_PREFERENCE_CHANGED,
    payload,
  };
};

export const eventUnixTimeChanged = (payload: number) => {
  return {
    type: EVENT_UNIX_TIME_CHANGED,
    payload,
  };
};

export const eventDataChanged = (payload: {
  eventName: string;
  eventClassification: string;
  hymotsDB: number | undefined;
  hlaContent: HLAGuncellemeType | undefined;
}) => {
  return {
    type: EVENT_DATA_CHANGED,
    payload,
  };
};

export const hymotseLogin = (payload: boolean) => {
  return {
    type: HYMOTSE_LOGIN,
    payload,
  };
};

export const hlaContentChanged = (payload: HLAGuncellemeType | undefined) => {
  return {
    type: HLA_CONTENT_CHANGED,
    payload,
  };
};
